export default "__VITE_ASSET__BNUBoGmZ__"